import { Stack, Typography } from '@mui/material'
import { useMinimalsTheme } from '../../../hooks'

interface Props {
  label: string
  value?: string | number
  nowrap?: boolean
  labelDataCy?: string
  valueDataCy?: string
}
export const DashboardTile = ({ label, value, nowrap, labelDataCy, valueDataCy }: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Stack gap={theme.customSpacing.xs}>
      <Typography
        variant='subtitle2'
        whiteSpace={nowrap ? 'nowrap' : 'normal'}
        color='secondary'
        data-cy={labelDataCy}
      >
        {label}
      </Typography>
      <Typography variant='h3' whiteSpace={nowrap ? 'nowrap' : 'normal'} data-cy={valueDataCy}>
        {value}
      </Typography>
    </Stack>
  )
}
